import { msg } from '@lingui/core/macro';
import { z } from 'zod';

import { isCivilDate } from '@/shared/format/date';
import { listSearchSchema } from '@/shared/patterns/list-search';

import { INCONSISTENCY_FILTERS } from './conciliation.filters';

// Leve de propósito: entra no arquivo da rota (bundle inicial). Só zod, Lingui e os filtros.

const civil = z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine(isCivilDate).optional().catch(undefined);
const ids = z.array(z.string().min(1).max(64)).max(100).optional().catch(undefined);

/** Lista Dataprev: só página e tamanho (os filtros do legado estão comentados, ConciliationDataprevList.tsx:122-126). */
export const dataprevListSearch = listSearchSchema({});
export type DataprevListSearch = z.output<typeof dataprevListSearch>;

/**
 * Nova conciliação: o período consultado vive na URL (F5 e o agente reabrem a mesma prévia); a página da
 * prévia a partir de 1; `sheet=gerar` abre "Gerar processo".
 */
export const newConciliationSearch = listSearchSchema({
  startDate: civil,
  endDate: civil,
  bookkeepingStartDate: civil,
  bookkeepingEndDate: civil,
  sheet: z.enum(['gerar']).optional().catch(undefined),
});
export type NewConciliationSearch = z.output<typeof newConciliationSearch>;

/** Abas do detalhe, na ordem e com o rótulo da `TabBar` (ConciliationDataprevDetails.tsx:16-27, U44). */
export const DETAIL_TABS = [
  { id: 'informacoes', label: msg`Informações`, icon: 'file-text' },
  { id: 'inconsistencias', label: msg`Inconsistências`, icon: 'shield-alert' },
  { id: 'nao-encerradas', label: msg`Não encerradas`, icon: 'file-text' },
  { id: 'linha-de-repasse', label: msg`Linha de repasse`, icon: 'receipt-text' },
  { id: 'historico', label: msg`Histórico`, icon: 'file-text' },
] as const;
export type DetailTab = (typeof DETAIL_TABS)[number]['id'];
const TAB_IDS = DETAIL_TABS.map((tab) => tab.id) as [DetailTab, ...DetailTab[]];

/**
 * Gavetas do detalhe pela URL (U26): relatórios, as tratativas da linha (`line`), o lote das selecionadas e o
 * painel de filtros do iPhone (`filtros`, o `overlay` da `FilterBar`).
 */
export const DETAIL_SHEETS = ['relatorios', 'tratativa', 'bolsao', 'juros', 'desvincular', 'observacoes', 'lote', 'bolsao-lote', 'filtros'] as const;
export type DetailSheet = (typeof DETAIL_SHEETS)[number];

/** Carteira do detalhe: um código ou -1 ("Vazio"). Chega texto ou número pela URL. */
const walletCode = z
  .preprocess((value) => (typeof value === 'string' && /^-?\d+$/.test(value) ? Number(value) : value), z.number().int().min(-1))
  .optional()
  .catch(undefined);

export const detailSearch = listSearchSchema({
  tab: z.enum(TAB_IDS).optional().catch(undefined),
  sheet: z.enum(DETAIL_SHEETS).optional().catch(undefined),
  line: z.string().min(1).max(200).optional().catch(undefined),
  selected: ids,
  walletCode,
  ...INCONSISTENCY_FILTERS.shape,
});
export type DetailSearch = z.output<typeof detailSearch>;
